import { defineStore } from "pinia";

type DiagnosticsStoreState = {
  sectionSelections: string[];
};

export const useDiagnosticsStore = defineStore({
  id: "diagnostics",
  persist: true,
  state: () =>
    ({
      sectionSelections: []
    }) as DiagnosticsStoreState,
  getters: {},
  actions: {
    setSectionSelections(selections: string[]) {
      this.sectionSelections = selections;
    }
  }
});
